// extracted by mini-css-extract-plugin
export default {"sun":"DarkModeToggle_sun__zeZin","moon":"DarkModeToggle_moon__iUBaF"};